import { useSelector } from 'react-redux';

// styles
import styles from './social-share.module.scss';

// components
import SocialShareIcon from './SocialShareIcon';
import { SearchIndexOff } from '../SearchIndex/SearchIndexOff';
import { CopyToClipboard } from 'components/copy-to-clipboard/copy-to-clipboard';

import SOCIAL_SHARE_DATA from './constants';

// utils
import { classNameBuilder } from 'utils/classNameBuilder';
import { baseURLSelector } from 'utils/selectors/globalsSelectors';

type SocialShareViewProps = {
  contentType: 'page' | 'video';
  metaData: Record<string, any>;
  hashtags: string[];
  className?: string;
  headline?: React.ReactNode;
  useInContentPage?: boolean;
  isGddsLightbox?: boolean;
};

export default function SocialShareView({
  hashtags,
  metaData,
  headline,
  contentType,
  useInContentPage,
  isGddsLightbox,
}: Readonly<SocialShareViewProps>) {
  const baseURL = useSelector(baseURLSelector);
  const isUrlAbsolute = /^https?:\/\/.*/.test(metaData.og_url);
  const ogUrl = isUrlAbsolute ? metaData.og_url : `${baseURL}${metaData.og_url}`;
  const metaDataUrl = metaData.url || ogUrl;

  return (
    <SearchIndexOff>
      <div
        className={classNameBuilder(
          useInContentPage && styles.use_in_content_page,
          styles[`social_share${isGddsLightbox && '_gdds_lightbox'}`],
        )}
      >
        {headline && <span className={styles.social_share__name}>{headline}</span>}
        <div className={styles.social_share__icons}>
          {SOCIAL_SHARE_DATA.map((item) => (
            <SocialShareIcon
              key={`${item.symbol}-icon`}
              baseUrl={item.baseUrl}
              url={metaDataUrl}
              symbol={item.symbol}
              hashtags={hashtags}
              title={metaData.title}
              image={metaData.image}
              contentType={contentType}
              isGddsLightbox={isGddsLightbox}
            />
          ))}
          {isGddsLightbox && metaDataUrl && <CopyToClipboard text={metaDataUrl} isIcon />}
        </div>
      </div>
    </SearchIndexOff>
  );
}
